import JsBarcode from 'jsbarcode';
import { DOMImplementation, XMLSerializer } from 'xmldom';
import img from '../../../assests/logo.jpg'

export class Impressao {

  constructor(dadosParaImpressao) {
    this.dadosParaImpressao = dadosParaImpressao;
  }

  async PreparaDocumento() {
    const corpoDocumento = this.CriaCorpoDocumento();
    const documento = this.GerarDocumento(corpoDocumento);
    return documento;
  }

  gerarBarcodeSvg(code) {
    const xmlSerializer = new XMLSerializer();
    const document = new DOMImplementation().createDocument('http://www.w3.org/1999/xhtml', 'html', null);
    const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    JsBarcode(svgNode, code, {
      xmlDocument: document,
      width: 2,
      height: 60,
      fontSize: 16,
      margin: 0,
      displayValue: true,
    });

    return xmlSerializer.serializeToString(svgNode);
  }

  criaPaginaMolde({ mold, piece }) {
    const wagon = this.dadosParaImpressao.wagon;
    const combinacao = this.dadosParaImpressao.typesPiecesCombinations;
    const isUltimaPassagem = mold.molde_QtdPassagens + 1 === mold.molde_QtdPassagensMAX;

    const cabecalhoVagao = {
      layout: 'noBorders',
      margin: [0, 0, 0, 12],
      table: {
        widths: ['*', '*', '*'],
        body: [
          [
            { text: 'VAGÃO', bold: true, fontSize: 10, color: '#666666' },
            { text: 'FORNO', bold: true, fontSize: 10, color: '#666666' },
            { text: 'COMBINAÇÃO', bold: true, fontSize: 10, color: '#666666' },
          ],
          [
            { text: wagon.vagao_Serial ?? '', fontSize: 18, bold: true },
            { text: combinacao?.forno ?? '', fontSize: 18, bold: true },
            { text: combinacao?.comb_Nome ?? '', fontSize: 14, bold: true },
          ],
        ],
      },
    };

    const tituloMolde = {
      text: 'MOLDE',
      fontSize: 12,
      bold: true,
      color: '#666666',
      margin: [0, 4, 0, 4],
    };

    const blocoMolde = {
      layout: {
        defaultBorder: false,
        fillColor: (rowIndex) => (rowIndex % 2 === 0 ? '#f4f4f4' : null),
        paddingTop: () => 6,
        paddingBottom: () => 6,
        paddingLeft: () => 8,
        paddingRight: () => 8,
      },
      margin: [0, 0, 0, 14],
      table: {
        widths: ['auto', '*', 'auto', '*'],
        body: [
          [
            { text: 'Código', bold: true, fontSize: 11, color: '#444444' },
            { text: mold.molde_Codigo ?? '', fontSize: 16, bold: true },
            { text: 'Lote', bold: true, fontSize: 11, color: '#444444' },
            { text: mold.molde_Lote ?? '', fontSize: 16, bold: true },
          ],
          [
            { text: 'Descrição', bold: true, fontSize: 11, color: '#444444' },
            { text: mold.molde_Descricao ?? '', fontSize: 13, colSpan: 3 },
            {},
            {},
          ],
          [
            { text: 'Endereço', bold: true, fontSize: 11, color: '#444444' },
            { text: mold.molde_SAPLocal ?? '', fontSize: 14, bold: true },
            { text: 'Buffer', bold: true, fontSize: 11, color: '#444444' },
            { text: !piece.rack_Buffer ? 'FORA' : piece.rack_Buffer, fontSize: 14, bold: true },
          ],
          [
            { text: 'Passagens', bold: true, fontSize: 11, color: '#444444' },
            {
              text: `${mold.molde_QtdPassagens ?? 0} / ${mold.molde_QtdPassagensMAX ?? 0}`,
              fontSize: 14,
              bold: true,
            },
            { text: 'Última Passagem', bold: true, fontSize: 11, color: '#444444' },
            isUltimaPassagem
              ? {
                  text: '⚠ SIM',
                  fontSize: 14,
                  bold: true,
                  color: '#ffffff',
                  fillColor: '#e07000',
                  alignment: 'center',
                  link: `sagaprintserver:BR_Molde;SAGA_User;${mold.molde_Codigo}`,
                }
              : { text: 'Não', fontSize: 14, bold: true },
          ],
        ],
      },
    };

    const tituloPeca = {
      text: 'PEÇA / ORDEM',
      fontSize: 12,
      bold: true,
      color: '#666666',
      margin: [0, 4, 0, 4],
    };

    const formatBomba = (p) => {
      const partes = [];
      if (p.bomba_A) {
        const min = p.tol_A_Min ? ` -${p.tol_A_Min}` : '';
        const max = p.tol_A_Max ? ` +${p.tol_A_Max}` : '';
        partes.push(`A ${parseInt(p.bomba_A)}${min}${max}`);
      }
      if (p.bomba_B) {
        const min = p.tol_B_Min ? ` -${p.tol_B_Min}` : '';
        const max = p.tol_B_Max ? ` +${p.tol_B_Max}` : '';
        partes.push(`B ${parseInt(p.bomba_B)}${min}${max}`);
      }
      if (p.bomba_C) {
        const min = p.tol_C_Min ? ` -${p.tol_C_Min}` : '';
        const max = p.tol_C_Max ? ` +${p.tol_C_Max}` : '';
        partes.push(`C ${parseInt(p.bomba_C)}${min}${max}`);
      }
      return partes.length ? partes.join('  |  ') : '—';
    };

    const formatMetragem = (p) => (p.m2_Peca != null && p.m2_Peca !== '' ? `${p.m2_Peca} m²` : '—');

    const blocoPeca = {
      layout: {
        defaultBorder: false,
        fillColor: (rowIndex) => (rowIndex % 2 === 0 ? '#f4f4f4' : null),
        paddingTop: () => 6,
        paddingBottom: () => 6,
        paddingLeft: () => 8,
        paddingRight: () => 8,
      },
      margin: [0, 0, 0, 14],
      table: {
        widths: ['auto', '*', 'auto', '*'],
        body: [
          [
            { text: 'Ordem Serial', bold: true, fontSize: 11, color: '#444444' },
            { text: piece.ordem_Serial ?? '', fontSize: 14, bold: true },
            { text: 'Peça', bold: true, fontSize: 11, color: '#444444' },
            { text: piece.ordem_Part_Short ?? '', fontSize: 14, bold: true },
          ],
          [
            { text: 'Produto', bold: true, fontSize: 11, color: '#444444' },
            { text: piece.subProduto_Desc ?? '', fontSize: 13, colSpan: 3 },
            {},
            {},
          ],
          [
            { text: 'Cód. Veículo', bold: true, fontSize: 11, color: '#444444' },
            { text: piece.ordem_VehCod ?? '', fontSize: 14, bold: true },
            { text: 'Descrição Veículo', bold: true, fontSize: 11, color: '#444444' },
            { text: piece.ordem_VehDesc ?? '', fontSize: 13 },
          ],
          [
            { text: 'Bombas', bold: true, fontSize: 11, color: '#444444' },
            { text: formatBomba(piece), fontSize: 12, bold: true },
            { text: 'Metragem', bold: true, fontSize: 11, color: '#444444' },
            { text: formatMetragem(piece), fontSize: 14, bold: true },
          ],
        ],
      },
    };

    const tituloOrdens = {
      text: 'ORDENS DESTE VAGÃO',
      fontSize: 10,
      bold: true,
      color: '#666666',
      margin: [0, 2, 0, 3],
    };

    const ordensVagao = {
      layout: {
        hLineWidth: (i) => (i === 0 || i === 1 ? 0.6 : 0.3),
        vLineWidth: () => 0,
        hLineColor: () => '#cccccc',
        paddingTop: () => 2,
        paddingBottom: () => 2,
        paddingLeft: () => 4,
        paddingRight: () => 4,
      },
      margin: [0, 0, 0, 8],
      table: {
        headerRows: 1,
        widths: ['auto', 'auto', 'auto', 'auto', '*', 'auto'],
        body: [
          [
            { text: 'Ordem', bold: true, fontSize: 8, color: '#555555' },
            { text: 'Peça', bold: true, fontSize: 8, color: '#555555' },
            { text: 'Veículo', bold: true, fontSize: 8, color: '#555555' },
            { text: 'M²', bold: true, fontSize: 8, color: '#555555', alignment: 'right' },
            { text: 'Bombas', bold: true, fontSize: 8, color: '#555555' },
            { text: 'Molde', bold: true, fontSize: 8, color: '#555555' },
          ],
          ...this.dadosParaImpressao.moldsWagon.map(({ mold: m, piece: p }) => [
            { text: p.ordem_Serial ?? '', fontSize: 8, bold: p.ordem_Serial === piece.ordem_Serial },
            { text: p.ordem_Part_Short ?? '', fontSize: 8 },
            { text: p.ordem_VehCod ?? '', fontSize: 8 },
            { text: formatMetragem(p), fontSize: 8, alignment: 'right' },
            { text: formatBomba(p), fontSize: 8 },
            { text: m.molde_Codigo ?? '', fontSize: 8 },
          ]),
        ],
      },
    };

    const codigoBarras = {
      svg: this.gerarBarcodeSvg(mold.molde_Codigo ?? '0'),
      alignment: 'center',
      margin: [0, 12, 0, 0],
    };

    const alertaUltimaPassagem = {
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: '⚠  ATENÇÃO — ÚLTIMA PASSAGEM DESTE MOLDE  ⚠',
              fontSize: 22,
              bold: true,
              color: '#ffffff',
              fillColor: '#c0392b',
              alignment: 'center',
              margin: [0, 14, 0, 14],
            },
          ],
        ],
      },
      layout: 'noBorders',
      margin: [0, 0, 0, 14],
    };

    const conteudo = [cabecalhoVagao, tituloMolde, blocoMolde];
    if (isUltimaPassagem) conteudo.push(alertaUltimaPassagem);
    conteudo.push(tituloPeca, blocoPeca, tituloOrdens, ordensVagao, codigoBarras);
    return conteudo;
  }

  CriaCorpoDocumento() {
    const moldsValidos = this.dadosParaImpressao.moldsWagon.filter(({ mold, piece }) => {
      const filtrado = this.dadosParaImpressao.wagon?.isagA_Vagoes_Fornos_Pecas?.some(
        w => (w.ordem_Serial === piece.ordem_Serial && !w.ativo) || mold.molde_Status === "INDISPONIVEL"
      );
      return !filtrado;
    });

    const content = [];
    moldsValidos.forEach((item, index) => {
      content.push(...this.criaPaginaMolde(item));
      if (index < moldsValidos.length - 1) {
        content.push({ text: '', pageBreak: 'after' });
      }
    });

    return content;
  }

  GetBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  async GerarDocumento(content) {
    const dataImpressao = new Date().toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });

    const documento = {
      pageSize: 'A4',
      pageMargins: [30, 60, 30, 40],
      header: function () {
        return {
          margin: [20, 16, 20, 0],
          layout: 'noBorders',
          table: {
            widths: ['*'],
            body: [
              [
                {
                  text: 'PREPARAÇÃO DE VAGÔES',
                  bold: true,
                  fontSize: 18,
                  alignment: 'center',
                },
              ],
            ],
          },
        };
      },

      content,

      images: {
        snow: await this.GetBase64ImageFromURL(img),
      },

      footer(currentPage, pageCount) {
        return {
          layout: 'noBorders',
          margin: [20, 0, 20, 16],
          table: {
            widths: ['*', '*', '*'],
            body: [
              [
                {
                  text: `Impresso em ${dataImpressao}`,
                  fontSize: 8,
                  alignment: 'left',
                },
                {
                  text: '© AGP Brasil',
                  fontSize: 8,
                  alignment: 'center',
                },
                {
                  text: `Página ${currentPage.toString()} de ${pageCount}`,
                  fontSize: 8,
                  alignment: 'right',
                },
              ],
            ],
          },
        };
      },
    };

    return documento;
  }
}
